import qs from 'qs'
import { HTTP } from './helpers/http'

export default {
  getInsight({ organizationId, insight, site, dateRange, category, limit }) {
    const params = {
      dateRange,
      site,
      category,
      limit,
    }
    return HTTP.get(
      `/api/v2/organizations/${organizationId}/insights/${insight}`,
      {
        params,
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      }
    )
  },

  getPredictedFinancialImpactInsight({ organizationId, query }) {
    return HTTP.get(
      `/api/v2/organizations/${organizationId}/insights/predicted-financial-impact-in-usd`,
      {
        params: query,
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      }
    )
  },
}
